<template>
    <div>
        <div property="schema:name" :content="product.title"></div>
        <div rel="schema:image" :resource="product.image.url"></div>

        <div class="section p-4 space-y-4 sticky top-24">
            <div class="flex justify-center mb-5">
                <ResponsiveImage
                  class="object-contain max-h-96"
                  :media-item="product.image"
                  :alt="product.title"
                />
            </div>
            <ProductTitle class="lg:hidden" :product="product" :reviews="reviews"/>

            <slot/>
        </div>
    </div>
</template>

<script>
import ProductTitle from "@/Partials/Products/ProductTitle.vue";
import ResponsiveImage from "@/Components/ResponsiveImage.vue";

export default {
    components: {ResponsiveImage, ProductTitle},
    props: {
        product: Object,
        reviews: Object,
    }
}
</script>
